import DaoChannel from "./channel";

/**
 * 하단 플레이어에서 사용되는 채널 객체
 */
export default class DaoPlayerChannel extends DaoChannel {

    constructor(json=null) {
        super(json);
    }
}


// WEBPACK FOOTER //
// ./src/modules/dao/player.channel.js